import gql from "graphql-tag";
const ClearSelectedCompaniesHistoryMutation = gql`
  mutation ClearSelectedCompaniesHistory {
    clearSelectedCompaniesHistory
  }
`;
export default ClearSelectedCompaniesHistoryMutation;
